module.exports = __webpack_public_path__ + "img/class-bg.62305191.png";